import { get, sortBy } from 'lodash';
import moment from 'moment';
import { TimeFormatType } from '../../../../../common/components/TimeFormat/TimeFormat';
import { TELEMETRY_TIME_FORMAT } from '../../../../../common/constants/telemetry';
import { PG_EXTERNAL_TYPES, PG_GRAPH_TYPES, PG_NODES_TYPES } from '../../../../../common/constants/plaza/graphs/graphConstants';
import { plazaGraphsActionTypes } from '../../../../../common/constants/plaza/graphs/store/constants';
import { prefix } from './constants';

const types = plazaGraphsActionTypes(prefix);

const defaultState = {
  initialValues: {
    plazaUuid: null,
    graphType: PG_GRAPH_TYPES.LOAD,
    dates: {
      startDate: Number(moment().utc().subtract(10, 'h').startOf('minute').format(TELEMETRY_TIME_FORMAT)),
      endDate: Number(moment().utc().startOf('minute').format(TELEMETRY_TIME_FORMAT)),
    },
  },
  meterModel: null,
  plazaList: [],
  plaza: {},
  topology: [],
  nodes: null,
  isFetching: {},
  timeSeries: null,
  timeZone: {
    format: TimeFormatType.UTC,
    offset: 0,
  },
};

function plazaReportReducer(state = defaultState, action) {
  switch (action.type) {
    case types.SET_DEFAULT_VALUES: {
      return {
        ...state,
        initialValues: {
          ...state.initialValues,
          ...action.payload,
        },
      };
    }

    case types.SET_PLAZA_LIST:
      return { ...state, plazaList: action.payload };

    case types.SET_METER_MODEL:
      return { ...state, meterModel: action.payload };

    case types.SET_PLAZA:
      return { ...state, plaza: action.payload };

    case types.SET_TOPOLOGY_NODES:
      return { ...state, topology: action.data };

    case types.SET_NODES:
      return { ...state, nodes: { ...state.nodes, [action.payload.nodeType]: action.payload.data } };

    case types.SET_TIME_ZONE:
      return { ...state, timeZone: action.timeZone };

    case types.CLEAR_TIME_SERIES:
      return { ...state, timeSeries: null };

    case types.SET_CONSTRAINTS_DATA:
      return { ...state, timeSeries: { ...state.timeSeries, [PG_NODES_TYPES.CONSTRAINT]: action.payload } };

    case types.SET_CHARGERS_DATA:
      return { ...state, timeSeries: { ...state.timeSeries, [PG_NODES_TYPES.CHARGER]: action.payload } };

    case types.SET_TOTALS_DATA:
      return { ...state, timeSeries: { ...state.timeSeries, [PG_EXTERNAL_TYPES.TOTAL]: action.payload } };

    case types.SET_METER_DATA: {
      const meterTimeSeries = {};

      for (const externalId in action.payload) {
        const nextData = get(action.payload, externalId, {});

        for (const metricCode in nextData) {
          if (!meterTimeSeries[externalId]) {
            meterTimeSeries[externalId] = {};
          }
          meterTimeSeries[externalId][metricCode] = sortBy(nextData[metricCode], 'ts');
        }
      }

      return { ...state, timeSeries: { ...state.timeSeries, [PG_NODES_TYPES.MEASURE]: meterTimeSeries } };
    }

    case types.SET_IS_FETCHING:
      return { ...state, isFetching: { ...state.isFetching, [action.nodeType]: action.value } };

    case types.RESET:
      return defaultState;

    default:
      return state;
  }
}

export default plazaReportReducer;
